export { default } from "./PurchasesConfirmationList"
